<script setup lang="ts">
const props = defineProps<{
    title: string,
    items: Array<{
        title: string,
        desc: string,
        img: string,
    }>
}>();
</script>

<template>
    <SectionsBase class="container">
        <ChipsDivider>ویژگی‌ها</ChipsDivider>
        <h2>{{ props.title }}</h2>
        <div class="w-full flex flex-col gap-6 lg:gap-8 mt-6 lg:mt-8">
            <div 
                v-for="item, index in items"
                :key="item.title"
                class="py-6 px-4 bg-gray-50 border border-gray-100 lg:border-0 lg:bg-transparent rounded-xl
                    flex flex-col lg:items-center gap-6 lg:gap-14"
                :class="index % 2 ? 'lg:flex-row-reverse' : 'lg:flex-row'"
            >
                <div class="w-full lg:w-1/2">
                    <h3 class="text-center lg:text-start">{{ item.title }}</h3>
                    <p class="text-body2 lg:text-[1rem]! text-gray-400 mt-3 lg:mt-6">{{ item.desc }}</p>
                </div>
                <div 
                    class="img-wrapper"
                    data-aos="fade-up" 
                    data-aos-duration="1000"
                >
                    <NuxtImg 
                        width="500"
                        :src="item.img"
                        :alt="item.title"
                        class="w-full relative z-1 max-w-125"
                        loading="lazy"
                    />
                </div>
            </div>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.img-wrapper {
    @apply
    w-full lg:w-1/2 relative flex justify-center items-center
}
.img-wrapper::before {
    @apply
    content-[''] absolute w-1/2 h-1/2 lg:w-1/3 lg:h-1/3 rounded-full bg-primary-200 blur-[50px] lg:blur-[80px]
}
</style>